import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { Button } from './shadcn/button'
import { Plus } from 'lucide-react'

type Props = {
  children: React.ReactNode
  onClose?: () => void
  theme?: 'light' | 'dark'
  className?: string
}

export function PopupWrapper({ children, onClose, className = '' }: Props) {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return createPortal(
    <div className="backdrop-blur-xs fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative flex flex-col items-center justify-center">
        {onClose && (
          <Button
            className="hover:bg-hover absolute -right-3 -top-3 flex h-8 w-8 rounded-full bg-white shadow-lg transition-colors"
            onClick={onClose}>
            <Plus className="rotate-45 text-black" />
          </Button>
        )}

        <div className={`bg-background w-full rounded-lg shadow-xl ${className}`}>{children}</div>
      </div>
    </div>,
    document.body,
  )
}
